export var IPublicModelDragObject = function IPublicModelDragObject() {
  this.type = void 0;
  this.data = void 0;
  this.nodes = void 0;
};